<app-loading *ngIf="toggleLoading"></app-loading>

<section class="notifications" *ngIf="!toggleLoading && notifications?.length">
    <div class="container">
        <div class="table-container text-left">
            <table style="width: 100%">
                <tr>
                    <th>{{ "notifications.image" | translate }}</th>
                    <th>{{ "notifications.title" | translate }}</th>
                    <th>{{ "orders.date" | translate }}</th>
                    <th>{{ "notifications.description" | translate }}</th>
                    <th></th>
                </tr>
                <tr
                    *ngFor="
                        let notification of notifications
                            | paginate
                                : {
                                      itemsPerPage: 10,
                                      currentPage: currentPage,
                                      totalItems: totalPage
                                  };
                        let i = index
                    "
                >
                    <td>
                        <img  loading="lazy" 
                            [src]="notification?.image"
                            *ngIf="notification?.image"
                            class="notifiaction-img"
                               [alt]="notification?.image"
                        />
                        <span *ngIf="!notification?.image">-</span>
                    </td>
                    <td class="bold">
                        {{
                            lang == "en"
                                ? notification?.title
                                : notification?.title_ar || notification?.title
                        }}
                    </td>
                    <td class="bold">
                        {{
                            lang == "en"
                                ? (notification?.created_at
                                  | date: "MMMM d, y":"":"en-US")
                                : (notification?.created_at
                                  | date: "MMMM d, y":"":"ar-EG")
                        }}
                    </td>
                    <td>
                        <p class="notification-body">
                            {{
                                lang == "en"
                                    ? notification?.body
                                    : notification?.body_ar ||
                                      notification?.body
                            }}
                        </p>
                    </td>
                    <td>
                        <a
                            class="route-icon"
                            (click)="openLink(i, notification?.type)"
                        >
                            <img  loading="lazy" 
                                src="./../../../assets/images/eye.png"
                                   alt="eye image"
                            />
                        </a>
                    </td>
                </tr>
            </table>
            <div class="pagination">
                <pagination-controls
                    class="product-pagination"
                    (pageChange)="onPageChanged($event)"
                    nextLabel="{{ 'button.next' | translate }}"
                    previousLabel="{{ 'button.previous' | translate }}"
                >
                </pagination-controls>
            </div>
        </div>
        <!-- <div class="alert alert-info" *ngIf="!toggleLoading && !notifications?.length">
    {{ 'notifications.emptyNotifications' | translate }}
  </div> -->
    </div>
</section>
<ng-container *ngIf="!notifications?.length && !toggleLoading">
    <div class="section-gap-lg text-center cartEmpty">
        <div class="mb-4">
            <mat-icon class="material-icons notifications-icon">
                notifications
            </mat-icon>
        </div>
        <h4>{{ "notifications.noNotifications" | translate }}</h4>
        <a
            href="javascript:void(0)"
            class="primary-color"
            [routerLink]="['/' + lang + '/']"
        >
            {{ "cart.goForShopping" | translate }}
        </a>
    </div>
</ng-container>
